import { render, staticRenderFns } from "./Devize_nefacturate_list.vue?vue&type=template&id=805fff76&scoped=true&"
import script from "./Devize_nefacturate_list.vue?vue&type=script&lang=js&"
export * from "./Devize_nefacturate_list.vue?vue&type=script&lang=js&"
import style0 from "./Devize_nefacturate_list.vue?vue&type=style&index=0&id=805fff76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "805fff76",
  null
  
)

export default component.exports